module.exports = __webpack_public_path__ + "static/media/sweden.97965f81.svg";